export type AddRepertoireSummaryParams = {
  mode?: 'create' | 'edit';
  arrangementName: string | null;
  pieceName: string | null;
  masteryShortLabel: string | null;
  queueStatusName: string | null;
  firstPracticeChoice: string | null;
  tunebookCount: number;
};

const FIRST_PRACTICE_NATURAL_COPY: Record<string, string> = {
  today: 'first up today',
  tomorrow: 'first up tomorrow',
  weekend: 'first up this weekend',
};

function firstPracticeClause(choice: string): string | null {
  return FIRST_PRACTICE_NATURAL_COPY[choice] ?? null;
}

export function buildAddRepertoireSummary(params: AddRepertoireSummaryParams): string {
  const {
    mode = 'create',
    arrangementName,
    pieceName,
    masteryShortLabel,
    queueStatusName,
    firstPracticeChoice,
    tunebookCount,
  } = params;

  if (pieceName === null) {
    return 'Add a tune…';
  }

  const verb = mode === 'edit' ? 'Save' : 'Add';
  const segments: string[] = [`${verb} ${pieceName}`];

  if (arrangementName !== null) segments.push(arrangementName);
  if (masteryShortLabel !== null) segments.push(masteryShortLabel);
  if (queueStatusName !== null) segments.push(queueStatusName);
  if (mode === 'create') {
    if (firstPracticeChoice !== null) {
      const clause = firstPracticeClause(firstPracticeChoice);
      if (clause !== null) segments.push(clause);
    }
    if (tunebookCount > 0) segments.push(`${tunebookCount} tunebooks`);
  }

  return segments.join(' · ');
}
